import Layout from "@/layouts";
import {i18n} from "@/utils/i18n";

const documentType = {
  path: "/scores",
  component: Layout,
  name: "scores",
  redirect: "/scores/index",
  children: [
    {
      path: "/scores/index",
      component: () => import("@/views/scores/index"),
      name: "scores.index",
      meta: { title: i18n.t(`message.scores`) },
    },
  ],
};

export default documentType;
